import React from "react";
import {useLazyQuery, useMutation, useSubscription} from "@apollo/client";
import {QUERY_USERS, USER_WALLET_DATA} from "../registryComponentsGQL.js";
import {Box, Button, Layer, Text} from "grommet";
import {DataGrid} from "@mui/x-data-grid";
import {GET_WALLET} from "./UserGQL.js";
import moment from "moment/moment.js";
import { IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import LayerMovementWallet from "./LayerMovementWallet.js";

function LayerWallet(props){
    const [portfolioData,setPortfolioData] = React.useState(null);
    const [movementList,setMovementList]=React.useState(null);
    const [showLayerMovementWallet,setShowLayerMovementWallet]=React.useState(false);

    const [ queryUserWalletData
    ]  = useLazyQuery(GET_WALLET, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {
            if(data["clubmate_clubmatewallet_clubmatewallet_by_pk"]){
                setPortfolioData(data?.clubmate_clubmatewallet_clubmatewallet_by_pk);
                setMovementList(transformData(data?.clubmate_clubmatewallet_clubmatewallet_by_pk?.clubmatewallet_movementwallets));
            }
        },
        onError:(error)=>{
            console.log(error);
        },
        notifyOnNetworkStatusChange: true, // did the work
    });

    const transformData = (data) => {
        if (!data) return [];
        return data.map((event) => ({
            id: event?.id,
            quantity: event?.quantity + " €",
            datetime: moment(event?.datetime).format("DD-MM-YYYY HH:mm:ss"),
            serviceName: event?.clubmateservice_clubmateservice?.name || "",
        }));
    };

    const getRowClassName = (params) => {
        const quantity = params.row.quantity.split(" ")[0];
        if (quantity < 0) {
            return 'lowQuantity';
        } else if (quantity == 0) {
            return 'mediumQuantity';
        } else {
            return 'highQuantity';
        }
    };

    React.useEffect(()=>{
        queryUserWalletData({variables:{id:props?.id}});
    },[])

    const columnsMovement = [
        { field: 'datetime', headerName: 'Data e ora movimento', width: 200 },
        { field: 'quantity', headerName: 'Quantità', width: 170 },
        { field: 'serviceName', headerName: 'Servizio', width: 200 },
    ];

    function onEscLayer(){
        setShowLayerMovementWallet(false)
    }

    return (
        <Layer onEsc={props?.onEscLayer} onClickOutside={props?.onEscLayer}>
            <Box margin={"medium"} gap={"medium"} overflow="auto"  height="100%" width="600px" alignSelf='center' style={{marginTop:'40px'}}>
                <Box direction={"raw"} width={"100%"} gap={"medium"}>
                    <Text>Ammontare: {portfolioData?.amount}€</Text>
                    <Button alignSelf={"end"} label={"Aggiungi movimento"} onClick={()=>{setShowLayerMovementWallet(true)}} style={{width:'180px',height:'34px',fontSize:'13px',background:'#f8b20e',color:'white',fontWeight:'bold',textTransform: 'uppercase'}}/>
                </Box>

                <div style={{ height: '75vh', width: '500px%' }}>
                    <DataGrid
                        rows={movementList || []}
                        columns={columnsMovement}
                        getRowClassName={getRowClassName}
                    />
                </div>
            </Box>
            {
                showLayerMovementWallet && <LayerMovementWallet onEscLayer={onEscLayer} wallet={props?.id} getData={()=> queryUserWalletData({variables:{id:props?.id}})}/>
            }
        </Layer>
    )
}

export default LayerWallet;